import { Component, inject, Input, signal } from '@angular/core';
import { arabicNameValidators, optionalName } from '../../../../validators/name-rules';
import { SuppliersService } from '../../../../services/suppliers/suppliers.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { OneSupplierResponseData } from '../../../../pages/admin-dashboard/admin-supplier/admin-supplier.model';

@Component({
  selector: 'app-admin-edit-supplier-component',
  imports: [ReactiveFormsModule],
  templateUrl: './admin-edit-supplier-component.html',
  styleUrl: './admin-edit-supplier-component.scss',
})
export class AdminEditSupplierComponent {
  @Input() supplierId!: number;

  private supplierService = inject(SuppliersService);
  private router = inject(Router);

  loading = signal<boolean>(false);
  loadingSupplier = signal<boolean>(false);
  errorUpdatingSupplier = signal<string | null>(null);

  formSubmitted = false;

  isActive = false;

  supplierForm = new FormGroup({
    titleEn: new FormControl('', [Validators.minLength(2), Validators.maxLength(100)]),
    titleAr: new FormControl('', arabicNameValidators(100)),
  });

  ngOnInit() {
    if (this.supplierId) {
      this.loadSupplier();
    }
  }

  loadSupplier() {
    this.loadingSupplier.set(true);
    this.supplierService.getOneSupplier(this.supplierId).subscribe({
      next: (supplier: OneSupplierResponseData) => {
        this.supplierForm.patchValue({
          titleEn: supplier.titleEn,
          titleAr: supplier.titleAr || '',
        });
        this.loadingSupplier.set(false);
      },
      error: (err) => {
        console.error('Error loading supplier:', err);
        this.loadingSupplier.set(false);
        this.errorUpdatingSupplier.set('Failed to load supplier. Please try again.');
      },
    });
  }

  onSubmit() {
    this.formSubmitted = true;

    if (this.supplierForm.invalid) {
      for (const key in this.supplierForm.controls) {
        this.supplierForm.get(key)?.markAsTouched();
      }
      return;
    }

    this.loading.set(true);
    this.errorUpdatingSupplier.set(null);

    this.updateSupplier();
  }

  private updateSupplier() {
    const formValue = this.supplierForm.getRawValue();
    const payload = {
      titleEn: optionalName(formValue.titleEn),
      titleAr: formValue.titleAr!.trim(),
    };

    this.supplierService.updateSupplier(this.supplierId, payload).subscribe({
      next: () => {
        this.loading.set(false);
        this.router.navigate(['/admin/suppliers']);
      },
      error: (err) => {
        console.error('Error updating supplier:', err);
        this.loading.set(false);
        this.errorUpdatingSupplier.set('Failed to update supplier. Please try again.');
      },
    });
  }

  onCancel() {
    this.router.navigate(['/admin/suppliers']);
  }
}
